export const DEFAULT_FEATURE_FLAGS = {
  test1: false, //FF example <key label>: <boolean value>
  AccFormHistory: false,
};
